import { PreguntaExportador } from "../PreguntaExportador";
import { FilasExcel, PreguntasTipoEnum, SingleSubtipoEnum } from "@shared/enums";
import { PreguntaDTO } from "@DTOS";
import { DatosEncuestaExportar } from "../DatosEncuestaExportar";

export class PreguntaSingleExportador extends PreguntaExportador {
    public puedeProcesar(tipoPregunta: PreguntasTipoEnum): boolean {
        return tipoPregunta === PreguntasTipoEnum.SINGLE_CHOICE;
    }

    protected generarFilaPregunta(datosEncuesta: DatosEncuestaExportar): Map<FilasExcel, string> {
        const preguntaCambio = new PreguntaDTO(datosEncuesta.pregunta.toJSON());
        switch (preguntaCambio.subtipo) {
        case SingleSubtipoEnum.REGULAR:
            break;
        case SingleSubtipoEnum.SINGLE_STATS:
            preguntaCambio.tipo = PreguntasTipoEnum.RESULTADO;
            break;
        case SingleSubtipoEnum.SINGLE_COMBO:
            preguntaCambio.tipo = PreguntasTipoEnum.DESPLEGABLE;
            break;
        case SingleSubtipoEnum.SINGLE_SLIDER:
            preguntaCambio.tipo = PreguntasTipoEnum.SLIDER_TEXT;
            break;
        case SingleSubtipoEnum.SINGLE_TEXT:
            preguntaCambio.tipo = PreguntasTipoEnum.ITEM_MATCH;
            break;
        }
        return super.generarFilaPregunta({
            ...datosEncuesta,
            pregunta: preguntaCambio
        });
    }
}
